// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3txWo","type":"styles_type__svsXt","choices":"styles_choices__2mYFr"};